<template>
  <b-card class="shadow" style="min-height: 700px" id="printme">
    <div class="row">
      <!-- Titulo --->
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h1 class="h3 mb-0 text-gray-800">
            {{ $t("Relatório SUAS Fácil") }}
          </h1>
          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button
              variant="outline-dark"
              @click="exportar()"
              :title="$t('Exportar')"
              v-b-tooltip.hover
            >
              <i class="fas fa-file-excel"></i>
            </b-button>
          </b-button-group>
        </div>
      </div>

      <!-- Filtros -->
      <div class="col-12" v-if="viewFilterReport">
        <form @submit.prevent="getAnalytics" ref="addItem">
          <div class="row">
            <form-calendar
              v-model="data_inicio"
              grid="6"
              label="Data inicial"
              :max-date="dataNowAt"
            />

            <form-calendar
              v-model="data_fim"
              grid="6"
              label="Data final"
              :required="verificaDataInicial"
              :min-date="data_inicio"
              :max-date="dataNowAt"
            />
          </div>
          <div class="row">
            <form-select
              v-model="filtroUnidades"
              label="Unidade(s)"
              grid="6"
              :itens="unidades"
              :disabled="desabledSearchUnidade"
              :loading="loadingSearchUnidade"
              multiple
            />

            <form-select
              v-model="filtroTecnicos"
              grid="6"
              label="Filtrar por Técnico"
              :itens="listtecnicos"
              :disabled="loadingSearchTecnicos"
              :loading="loadingSearchTecnicos"
              :multiple="true"
            />
          </div>
          <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
            <div class="col-auto px-2 text-right">
              <button
                class="btn btn-default"
                @click.prevent="limparFiltros(), (viewFilterReport = false)"
              >
                <i class="fas fa-times"></i>
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="limparFiltros()"
              >
                {{ $t("Limpar Filtros") }}
              </button>

              <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                type="submit"
              >
                <i class="fas fa-chart-bar"></i>
                {{ $t("Gerar Relatório") }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <loading-report
        :loading="isLoadingMsg"
        mensagem="Por favor aguarde estamos realizando sua solicitação..."
        icone="fa-smile-wink"
      ></loading-report>
      <load v-if="loadingTable" mode="table" />

      <div v-show="!loadingTable" class="col-md-12">
        <print-content>
          <template v-slot:datas>
            <p class="d-flex align-items-center justify-content-between mb-4">
              <span>
                Período selecionado:
                <b>{{ datas.start }} - {{ datas.end }}</b>
                <b-link
                  href="#"
                  @click.prevent="void 0"
                  class="mb-2"
                  variant="info"
                  v-b-popover.hover.top="
                    'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                  "
                >
                  <i class="fas fa-info-circle"></i>
                </b-link>
              </span>
            </p>
          </template>
        </print-content>
        <div class="table-responsive">
          <b-table
            :fields="[
              { key: 'unidade', label: $t('Unidades'), sortable: true },
              { key: 'tecnicos', label: $t('Equipe SUAS'), sortable: true },
              { key: 'acessos', label: $t('Acessos'), sortable: true },
              { key: 'oficios', label: $t('Ofícios'), sortable: true },
              {
                key: 'atendimentos',
                label: $t('Atendimentos'),
                sortable: true,
              },
              {
                key: 'tecnico_atendimento',
                label: $t('Técnico Atendimentos'),
                sortable: true,
              },
              {
                key: 'acompanhamentos',
                label: $t('Acompanhamentos'),
                sortable: true,
              },
              {
                key: 'tecnico_acompanhamento',
                label: $t('Técnico Acompanhamentos'),
                sortable: true,
              },
              {
                key: 'encaminhamentos',
                label: $t('Encaminhamentos'),
                sortable: true,
              },
              {
                key: 'tecnico_encaminhamento',
                label: $t('Técnico Encaminhamentos'),
                sortable: true,
              },
              {
                key: 'programas',
                label: $t('Programas Sociais'),
                sortable: true,
              },
              {
                key: 'tecnico_programaSocial',
                label: $t('Técnico Programas Sociais'),
                sortable: true,
              },
              { key: 'beneficios', label: $t('Benefícios'), sortable: true },
              {
                key: 'tecnico_beneficio',
                label: $t('Técnico Benefícios'),
                sortable: true,
              },
              { key: 'atividades', label: $t('Atividades'), sortable: true },
              {
                key: 'tecnico_atividade',
                label: $t('Técnico Atividades'),
                sortable: true,
              },
            ]"
            :items="itens"
            :responsive="true"
            striped
            hover
            show-empty
            small
            outlined
            stacked="xs"
            table-class="mb-3 text-nowrap"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            no-local-sorting
            @sort-changed="changeSort"
            style="max-height: 400px; overflow-y: auto"
          >
          </b-table>
        </div>
      </div>
    </div>
  </b-card>
</template>
<script>
export default {
  data() {
    return {
      isLoadingMsg: false,
      loadingTable: true,
      data_inicio: "",
      data_fim: "",
      filtroDatas: [],
      dataNowAt: moment().format("YYYY-MM-DD"),
      verificaDataInicial: false,
      itens: [],
      datas: [],
      tecnicos: [],
      loadingSearchTecnicos: true,
      filtroUnidades: [],
      filtroTecnicos: [],
      unidades: [],
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      sortBy: "unidade",
      sortDesc: false,
      order: "asc",
    };
  },
  mounted() {
    this.getAnalytics();
    this.getTecnicos();
    this.getUnidades();
  },
  computed: {
    listtecnicos() {
      const pessoas = this.tecnicos;
      const map = pessoas.map((elem) => ({
        id: elem.id,
        value:
          " <b>" +
          elem.value +
          "</b> - " +
          (elem.profissao ?? "Não informado") +
          " - " +
          elem.nome_unidade,
      }));
      return map;
    },
  },
  methods: {
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/relatorios/suasfacil", {
          params: {
            filtroDatas: this.filtroDatas,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            sort: {
              column: this.sortBy,
              order: this.order,
            },
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    changeSort(ctx) {
      this.sortBy = ctx.sortBy;
      this.order = ctx.sortDesc === true ? "desc" : "asc";
      this.getAnalytics();
    },
    limparFiltros() {
      this.verificaDataInicial = false;
      this.filtros = {};
      this.datas = [];
      this.filtroUnidades = [];
      this.filtroTecnicos = [];
      this.data_inicio = "";
      this.data_fim = "";
      this.getAnalytics();
    },
    getTecnicos() {
      this.tecnicos = [];
      this.loadingSearchTecnicos = true;
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`, {
          params: {
            unidades: this.filtroUnidades,
          },
        })
        .then((response) => {
          this.tecnicos = response.data;
        })
        .finally(() => (this.loadingSearchTecnicos = false));
    },
    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    getAnalytics() {
      this.isLoadingMsg = true;
      this.loading = true;
      this.loadingTable = true;

      this.filtroDatas = [];

      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/relatorios/suasfacil", {
          params: {
            filtroDatas: this.filtroDatas,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            sort: {
              column: this.sortBy,
              order: this.order,
            },
          },
        })
        .then((response) => {
          this.itens = response.data.itens;
          this.datas = response.data.datas;
          // console.log('itens',this.itens);
        })
        .finally(() => {
          setTimeout(() => {
            this.loadingTable = false;
            this.loading = false;
            this.isLoadingMsg = false;
          }, 2000);
        });
    },
  },
  watch: {
    data_inicio_at: function (val) {
      if (val != "" && this.data_fim_at == "") {
        this.verificaDataInicialAt = true;
      } else {
        this.verificaDataInicialAt = false;
      }
    },
  },
};
</script>
